import { configureStore } from "@reduxjs/toolkit";

import dataApi from "api";
import authReducer from "slices/auth";
import practiceReducer from "slices/practice";
import themeColoursReducer from "slices/themeColours";
import vocabularyFiltersReducer from "slices/vocabularyFilters";
import practiceStatFilterReducer from "slices/practiceStatFilters";
import practitionerFiltersReducer from "slices/practitionerFilters";
import practiceManagementFiltersReducer from "slices/practiceManagementFilters";

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(dataApi.middleware),
  reducer: {
    [dataApi.reducerPath]: dataApi.reducer,
    auth: authReducer,
    practice: practiceReducer,
    themeColours: themeColoursReducer,
    vocabularyFilters: vocabularyFiltersReducer,
    practiceStatFilters: practiceStatFilterReducer,
    practitionerFilters: practitionerFiltersReducer,
    practiceManagementFilters: practiceManagementFiltersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
